/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsApiErrorResponseSchema } from "./goodLuck/core/DTOs/apiErrorResponseSchema.ts";
import { goodLuckCoreDTOsRosterJoinResponseDtoSchema } from "./goodLuck/core/DTOs/rosterJoinResponseDtoSchema.ts";
import { z } from "zod/v4";

export const postTeamsInviteTokenPathParamsSchema = z.object({
  token: z.string(),
});

/**
 * @description OK
 */
export const postTeamsInviteToken200Schema = z.lazy(
  () => goodLuckCoreDTOsRosterJoinResponseDtoSchema,
);

/**
 * @description Bad Request
 */
export const postTeamsInviteToken400Schema = z.lazy(
  () => goodLuckCoreDTOsApiErrorResponseSchema,
);

/**
 * @description Unauthorized
 */
export const postTeamsInviteToken401Schema = z.lazy(
  () => goodLuckCoreDTOsApiErrorResponseSchema,
);

/**
 * @description Not Found
 */
export const postTeamsInviteToken404Schema = z.lazy(
  () => goodLuckCoreDTOsApiErrorResponseSchema,
);

/**
 * @description Internal Server Error
 */
export const postTeamsInviteToken500Schema = z.lazy(
  () => goodLuckCoreDTOsApiErrorResponseSchema,
);

export const postTeamsInviteTokenMutationResponseSchema =
  postTeamsInviteToken200Schema;
